import { Input, InputProps } from 'antd';
import { useState } from 'react';
import classNames from 'classnames';
import lessStyle from './index.module.less';
import searchIcon from './images/searchIcon.png';

interface InputBtnProps extends InputProps {
  isShowIcon?: boolean;
  searchButton?: string;
  isShowSearchButton?: boolean;
  onClick?: () => void;
  inputProps?: InputProps;
  btnStyle?: React.CSSProperties;
}
export default function InputBtn(props: InputBtnProps) {
  const {
    style,
    isShowIcon = true,
    isShowSearchButton = true,
    searchButton = '搜索',
    onClick,
    inputProps,
    btnStyle,
  } = props;
  const [isFocus, setIsFocus] = useState(false);
  return (
    <div
      className={
        classNames(lessStyle.inputSearch, { [lessStyle.isFocus]: isFocus })
      }
      style={style}
    >
      {
        isShowIcon && (
          <img src={searchIcon} alt="" />
        )
      }
      <Input
        variant="borderless"
        size="small"
        onFocus={() => setIsFocus(true)}
        onBlur={() => setIsFocus(false)}
        {...inputProps}
      />
      {
        isShowSearchButton && (
          <div className={lessStyle.searchButton} onClick={onClick}>
            <span style={btnStyle}>{searchButton}</span>
          </div>
        )
      }
    </div>
  );
}
